import React, { useContext, useMemo, useState } from "react"
import { useSelector } from "react-redux"
import { ReportContext } from "../ReportContext"
import { RateAndAccuracyDescription } from "../Style"
import { useTheme } from "styles"
import { Chip } from "components/Form"
import { Top } from "styles/GlobalStyle"
import { ratingListLabel3 } from "keys/rating"
import FactoredPercentAccuracyTooltip from "../FactoredPercentAccuracyTooltip"

const reading_fluency = {
    5: "מקוטע מאד",
    4: "מקוטע",
    3: "מעט מקוטע",
    2: "ברצף",
    1: "ברצף +"
}

const useRateAndAccuracyItems = () => {
    const {
        scoreRating, factoredAccuracyDistribution, correctWordsPerMinuteDistribution, accuracyDistribution, fluencyReadingDistribution, fluencyDistribution, factoredAccuracyStats, correctWordsPerMinuteStats, refetchCorrectWordsPerMinuteStats, fluencyReadingStats, refetchFluencyReadingStats, accuracyStats, fluencyStats,
        refetchAccuracyStats, refetchFactoredAccuracyStats, refetchFluencyStats
    } = useContext(ReportContext)

    const { rating } = useSelector(state => state.rating)
    const { Layout, Common } = useTheme()
    const { fluency_reading, fluency_reading_rating_id, fluency_reading_rating_index, percent_accuracy = "?", num_words_per_minute, factored_percent_accuracy, factored_percent_accuracy_rating_id, percent_accuracy_rating_id, correct_words_per_minute = "?", fluency_rating_id, correct_words_per_minute_rating_index, correct_words_per_minute_rating_id } = rating || {}

    const { rating: accuracy_rating, f_rating, color: accuracyColor, bg: accuracyBg } = scoreRating[percent_accuracy_rating_id] || {}
    const { rating: correct_words_per_minute_rating, f_rating: f_correct_words_per_minute, color: correct_words_per_minute_color, bg: correct_words_per_minute_bg } = scoreRating[correct_words_per_minute_rating_id] || {}
    const { rating: factored_rating, color: scColor, bg: scBg } = scoreRating[factored_percent_accuracy_rating_id] || {}
    const { color: fluency_reading_rating_color, bg: fluency_reading_rating_bg } = scoreRating[fluency_reading_rating_id] || {}
    const fluency_reading_rating = ratingListLabel3[fluency_reading_rating_index]
    const { percent_accuracy_rating, color: rateColor, bg: rateBg } = scoreRating[fluency_rating_id] || {}

    const rateAndAccuracyItems = useMemo(
        () => [
            {
                label: "קצב",
                type: "fluency",
                text: () =>
                    <React.Fragment>
                        <RateAndAccuracyDescription>
                            מילים לדקה
                        </RateAndAccuracyDescription>
                        {num_words_per_minute && percent_accuracy_rating &&
                            <Chip borderColor={rateColor} bg={rateBg}>
                                {` ${num_words_per_minute} מילים - ${percent_accuracy_rating} `}
                            </Chip>}
                    </React.Fragment>,
                color: rateColor,
                percent: false,
                expand: true,
                showGraphBtns: true,
                stats: fluencyStats,
                graph: fluencyDistribution,
                refetch: refetchFluencyStats
            },
            {
                label: "דיוק",
                type: "factored_accuracy",
                graph: "graph",
                text: () =>
                    <React.Fragment>
                        <RateAndAccuracyDescription style={{ ...Layout.flex }}>
                            אחוז דיוק משוקלל
                            <Top top={-7}>
                                <FactoredPercentAccuracyTooltip />
                            </Top>
                        </RateAndAccuracyDescription>

                        {factored_percent_accuracy && factored_rating &&
                            <Chip borderColor={scColor} bg={scBg}>
                                {`  ${factored_percent_accuracy}% - ${factored_rating}`}
                            </Chip>}
                    </React.Fragment>
                ,
                percent: true,
                expand: true,
                showGraphBtns: true,
                stats: factoredAccuracyStats,
                graph: factoredAccuracyDistribution,
                refetch: refetchFactoredAccuracyStats
            },
            {
                label: "דיוק",
                type: "accuracy",
                graph: "graph",
                text: () =>
                    <React.Fragment>
                        <RateAndAccuracyDescription>
                            אחוז דיוק לא משוקלל
                        </RateAndAccuracyDescription>
                        {percent_accuracy && accuracy_rating &&
                            <Chip borderColor={accuracyColor} bg={accuracyBg}>
                                {` ${percent_accuracy}% - ${accuracy_rating}`}
                            </Chip>}
                    </React.Fragment>
                ,
                percent: true,
                expand: true,
                showGraphBtns: true,
                stats: accuracyStats,
                graph: accuracyDistribution,
                refetch: refetchAccuracyStats
            },
            {
                label: "שטף",
                type: "accuracy",
                text: () =>
                    <React.Fragment>
                        <RateAndAccuracyDescription>
                            אופן הקריאה
                        </RateAndAccuracyDescription>
                        {fluency_reading && fluency_reading_rating &&
                            <Chip borderColor={fluency_reading_rating_color} bg={fluency_reading_rating_bg}>
                                {fluency_reading_rating}
                            </Chip>}
                    </React.Fragment>,
                expand: true,
                showGraphBtns: true,
                stats: fluencyReadingStats,
                graph: fluencyReadingDistribution,
                refetch: refetchFluencyReadingStats
            },
            {
                label: "",
                type: "correct_words_per_minute",
                text: () =>
                    <React.Fragment>
                        <RateAndAccuracyDescription>
                            מילים נכונות לדקה
                        </RateAndAccuracyDescription>
                        {correct_words_per_minute && correct_words_per_minute_rating &&
                            <Chip borderColor={correct_words_per_minute_color} bg={correct_words_per_minute_bg}>
                                {` ${correct_words_per_minute} מילים - ${correct_words_per_minute_rating}`}
                            </Chip>}
                    </React.Fragment>,
                expand: true,
                showGraphBtns: true,
                stats: correctWordsPerMinuteStats,
                graph: correctWordsPerMinuteDistribution,
                refetch: refetchCorrectWordsPerMinuteStats,
            }
        ], [correctWordsPerMinuteDistribution, fluencyReadingDistribution, fluencyReadingStats, correctWordsPerMinuteStats, rating, scoreRating, factoredAccuracyDistribution, accuracyDistribution, fluencyDistribution, factoredAccuracyStats, accuracyStats, fluencyStats]
    )

    return rateAndAccuracyItems
}

export default useRateAndAccuracyItems
